import React from "react";
import { useTranslation } from "@lib/i18n";

import Typography from "../shared/Typography";
import { ROUTES } from "@shared/routing/routes";

import Link from "next/link";
import { useRoutingUtils } from "@hooks/useRoutingUtils";
import { useTestDriveLinkOnHomePagePathSelector } from "@redux/reducers/appConfig";

import gtm from "@gtm/core";
import { linkTestDriveClickEvent } from "@gtm/events/homepage";

const TestDriveLink = () => {
  const { t, i18n } = useTranslation();
  const routingUtils = useRoutingUtils();
  const testDriveLinkPath = useTestDriveLinkOnHomePagePathSelector();

  const onTestDriveClick = path => {
    gtm.fire(
      linkTestDriveClickEvent({
        label: path,
      })
    );
  };

  return (
    <div className="flex flex-col justify-center items-center gap-8 w-full p-8 text-center bg-primaryDark text-white lg:flex-row">
      <div>
        <Typography className="text-lg text-white text-center text-balance lg:text-2xl">
          {t("testDrive.bookTestDrive")}
        </Typography>
      </div>
      <div>
        {testDriveLinkPath ? (
          <a
            className="
              flex justify-center items-center gap-1
              px-8 py-5 min-w-50
              border-2 border-primaryOrange bg-white text-primaryOrange 
              text-balance lowercase font-semibold
              cursor-pointer rounded-full transition duration-150
              hover:scale-105 hover:bg-primaryOrange hover:text-white
              active:scale-95
            "
            href={testDriveLinkPath}
            target="_blank"
            rel="noreferrer"
            onClick={() => onTestDriveClick(testDriveLinkPath)}
          >
            {t("testDrive.discoveryJourney")}
          </a>
        ) : (
          <Link
            href={ROUTES.TEST_DRIVE_INDEX}
            as={routingUtils.getLocalizedPathname(
              ROUTES.TEST_DRIVE_INDEX,
              null,
              i18n.language
            )}
            target="_blank"
            rel="noreferrer"
          >
            <a
              className="
                flex justify-center items-center gap-1
                px-8 py-5 min-w-50
                border-2 border-primaryOrange bg-white text-primaryOrange 
                lowercase font-semibold
                cursor-pointer rounded-full transition duration-150
                hover:scale-105 hover:bg-primaryOrange hover:text-white
                active:scale-95
              "
              onClick={() => onTestDriveClick(ROUTES.TEST_DRIVE_INDEX)}
              target="_blank"
            >
              {t("testDrive.discoveryJourney")}
            </a>
          </Link>
        )}
      </div>
    </div>
  );
};

TestDriveLink.propTypes = {};

export default TestDriveLink;
